'use client';

import { useEffect } from 'react';

import { usePathname } from 'next/navigation';

import { useAppDispatch, useAppSelector } from '@/store';
import { clearPetCreationState, resetState, setActiveStep } from '@/store/slices/petProfile';

export default function UnloadCreationFlow() {
  const dispatch = useAppDispatch();
  const isAuthenticated = useAppSelector(store => store.slices.authenticationSlice.isAuthenticated);
  const pathname = usePathname();

  useEffect(() => {
    if (pathname.includes('petprofile/createprofilenew')) return;
    if (pathname.includes('petprofile/createrecommendationnew') && !isAuthenticated) return;

    dispatch(clearPetCreationState());
    dispatch(setActiveStep(0));
    dispatch(resetState());
  }, [pathname, dispatch, isAuthenticated]);

  return null;
}
